import { CindiMessage } from './../models/cindi-message.model';
import { Injectable } from '@angular/core';

import { ConfirmInputService } from './confirm-input.service';
import { ButtonService } from './button.service';
import { MessageService } from './message.service';
import { AnswerService } from './answer.service';
import { AttachedFilesService } from './attached-files.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OptionsService {
  private openCountryModalSource = new Subject<void>();
  openCountryModal$ = this.openCountryModalSource.asObservable();

  constructor(
    private confirmInputService: ConfirmInputService,
    private messageService: MessageService,
    private buttonService: ButtonService,
    private answerService: AnswerService,
    private attachedFilesService: AttachedFilesService
  ) {}

  async generateMessageWithOptions(...params: any[]) {
    let questionId: number = params[0];
    let timeoutMessage: number = params[4];
    let question = this.messageService.returnCindiMessage(questionId);
    let answerOptionType: string = question.tipoMensagem;
    if (params[1] != undefined) answerOptionType = params[1];

    if (timeoutMessage) await this.messageService.addStringBotMsgToChat(question.texto, timeoutMessage);
    else await this.messageService.addStringBotMsgToChat(question.texto, 'auto');

    if (answerOptionType === 'Mensagem') return;

    else if (answerOptionType === 'Questão Escolha Única') {
      this.createSingleChoiceOptions(question);
    }

    else if (answerOptionType === 'Questão Múltipla Escolha') {
      let minSelected = params[2];
      let maxSelected = params[3];
      this.createMultipleChoiceOptions(question, minSelected, maxSelected);
    }

    else if (answerOptionType === 'Questão Múltipla Escolha Alternada') {
      let optionsGroup1 = [1, 2, 3];
      let optionsGroup2 = [4];
      if (params[2] != undefined) optionsGroup1 == params[2];
      if (params[3] != undefined) optionsGroup2 == params[3];
      this.createMultipleChoiceOptions(question, optionsGroup1, optionsGroup2);
    }

    else if (answerOptionType === 'Questão Aberta' && question.id == 9) {
      let chat = document.getElementById('chat');
      let btn = document.createElement('button');
      btn.classList.add('country-btn');
      btn.textContent = 'Clique para selecionar';
      chat?.appendChild(btn);

      btn.addEventListener('click', async () => {
        this.openCountryModalSource.next();
      })
    }

    else if (answerOptionType === 'Questão Aberta' && question.id !== 9) {
      let subject = question.tagMensagem;
      if (params[2] != undefined) subject = params[2];
      this.createOpenAnswer(question, subject);
    }

    document.querySelectorAll('.user-msg').forEach((p) => {
      p.classList.add('option-selected-disabled');
    });
    await this.confirmInputService.waitUserInput();
  }

  createSingleChoiceOptions = (question: CindiMessage) => {
    let numberOfOptions = question.alternatives.length;
    let allButtons = [];

    for (let i = 0; i < numberOfOptions; i++) {
      let selectedText = question.alternatives[i].texto;
      let btn = this.buttonService.createOptionBtn(selectedText);

      btn.addEventListener('click', async () => {
        this.buttonService.highlightSelectedOption(btn);
        await this.answerService.setAnswer(question, i);
        this.confirmInputService.changeInputStatus(true);
      });

      allButtons.push(btn);
    }

    if (allButtons.length % 2 === 1) {
      allButtons[allButtons.length - 1].classList.add('answer-option-last');
    }

    if (question.tagMensagem !== 'Avaliacao' && question.id !== 18)
      this.buttonService.createAnswerBox(allButtons);
    else if (question.tagMensagem === 'Avaliacao' || question.id == 18)
      this.buttonService.createRateButtons(allButtons, question.id);
  };

  createMultipleChoiceOptions = (...params: any[]) => {
    let question: CindiMessage = params[0];
    let minSelected: number = question.minOptions;
    let maxSelected: number = question.maxOptions || question.alternatives.length;
    let optionsGroup1: number[] | null = null;
    let optionsGroup2: number[] | null = null;

    if (params[1] != undefined)
      Array.isArray(params[1])
        ? (optionsGroup1 = params[1])
        : (minSelected = params[1]);
    if (params[2] != undefined)
      Array.isArray(params[2])
        ? (optionsGroup2 = params[2])
        : (maxSelected = params[2]);

    let numberOfOptions = question.alternatives.length;
    let allButtons = [];

    for (let i = 0; i < numberOfOptions; i++) {
      let checkboxBtn = this.buttonService.createCheckboxBtn(
        question.id,
        question.alternatives[i]
      );
      this.buttonService.toogleCheckboxByButtonClick(checkboxBtn);
      allButtons.push(checkboxBtn);
    }

    if (allButtons.length % 2 === 1) {
      allButtons[allButtons.length - 1].classList.add('answer-option-last');
    }

    let btn = this.buttonService.createSendBtnMultiple(
      question,
      minSelected,
      maxSelected
    );
    allButtons.push(btn);

    this.buttonService.createAnswerBox(allButtons);
    if (optionsGroup1 != null && optionsGroup2 != null)
      this.checkingAlternatedOptions(question, optionsGroup1, optionsGroup2);
      this.checkingMinMaxOptions(question, minSelected, maxSelected);
  };

  checkingMinMaxOptions(question: CindiMessage, min: number, max: number) {
    let name = `question${question.id}options`;
    let allCheckboxButtons = document.querySelectorAll(`.Q-${question.id}`);

    allCheckboxButtons.forEach((button) => {
      button.addEventListener('click', () => {
        let checkboxesChecked = document.querySelectorAll(
          `input[name=${name}]:checked`
        );
        let buttons = document.querySelectorAll('.send-btn');
        let sendBtn = buttons[buttons.length - 1];

        if (checkboxesChecked.length < min || checkboxesChecked.length > max) {
          (sendBtn as HTMLButtonElement).disabled = true;
          sendBtn.classList.add('lowlight');
        } else {
          (sendBtn as HTMLButtonElement).disabled = false;
          sendBtn.classList.remove('lowlight');
        }
      });
    });
  }

  checkingAlternatedOptions(
    question: CindiMessage,
    optionsGroup1: number[],
    optionsGroup2: number[]
  ) {
    let name = `question${question.id}options`;
    let allCheckboxes = document.querySelectorAll(`input[name=${name}]`);
    let allCheckboxButtons = document.querySelectorAll(`.Q-${question.id}`);

    allCheckboxButtons.forEach((button) => {
      button.addEventListener('click', () => {
        let group1Values = [];
        let group2Values = [];

        for (let optionNumber of optionsGroup1) {
          let value = allCheckboxes[optionNumber - 1].getAttribute('value')!;
          group1Values.push(value);
        }

        for (let optionNumber of optionsGroup2) {
          let value = allCheckboxes[optionNumber - 1].getAttribute('value')!;
          group2Values.push(value);
        }

        let self = button.children[0] as HTMLInputElement;
        if (self.checked) {
          let value = self.getAttribute('value')!;
          if (group1Values.includes(value)) {
            for (let checkbox of allCheckboxes) {
              if (group2Values.includes(checkbox.getAttribute('value')!))
                (checkbox as HTMLInputElement).checked = false;
            }
          } else if (group2Values.includes(value)) {
            for (let checkbox of allCheckboxes) {
              if (group1Values.includes(checkbox.getAttribute('value')!))
                (checkbox as HTMLInputElement).checked = false;
            }
          }
        }
      });
    });
  }

  createOpenAnswer(question: CindiMessage, details: string) {
    let chat = document.getElementById('chat');
    let div = document.createElement('div');
    div.classList.add('answer-options-div');
    let textDiv = document.createElement('div');
    textDiv.classList.add('answer-options-div', 'helpTtext-div');

    let btn = this.buttonService.createSendBtnOpen(question, details);

    let inputDiv = document.createElement('div');
    let input = document.createElement('input');
    let helpText = document.createElement('p');
    helpText.textContent = 'Digite de 5 a 255 caracteres.';

    inputDiv.classList.add('div-input-open-answer');
    input.classList.add('input-open-answer');
    helpText.classList.add('help-text');

    inputDiv.appendChild(input);
    div.appendChild(inputDiv);
    chat?.appendChild(div);
    chat?.appendChild(textDiv);
    let validInput: boolean = false;

    if (details === "Peso") {
      this.confirmInputService.createWeightInput(input, btn)
      helpText.textContent = "";
    } else if (details === "Altura") {
      this.confirmInputService.createHeightInput(input, btn);
      helpText.textContent = "";
    }

    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });

    textDiv.appendChild(helpText);

    input.addEventListener('keyup', (event: any) => {
      let value = input.value
        let valueFloat = value.replace(',', '.')

      switch (details) {
        case "Peso":
          parseFloat(valueFloat) < 200.0 && parseFloat(valueFloat) > 10.0 ? validInput = true : validInput = false
        break

        case "Altura":
          parseFloat(valueFloat) > 0.80 && parseFloat(valueFloat) <= 2.60 ? validInput = true : validInput = false
        break

        default:
          input.value !== "" && input.value.length > 4 && input.value.length < 256 ? validInput = true : validInput = false
        break
      }

      if (!validInput) {
        helpText.textContent = 'Digite um valor válido.';
      } else {
        helpText.textContent = '';
      }

      if (input.value !== '' && validInput) {
        btn.classList.remove('lowlight-send-btn');
        btn.disabled = false;
      } else {
        btn.classList.add('lowlight-send-btn');
        btn.disabled = true;
      }

      if (event.key == 'Enter' && !btn.disabled) {
        this.buttonService.sendBtnOpenData(question, btn, details);
        textDiv.remove();
        helpText.remove();
      }
    });

    input.focus();

    div.appendChild(btn);

    chat!.scrollTop = chat!.scrollHeight;
  }
}
